module.exports = __webpack_public_path__ + "img/qrcode1.02fb6393.png";